<template>
    <iframe
            class="instagram-media instagram-media-rendered"
            id="instagram-embed-11" :src="permalink + 'embed'"
            allowtransparency="true" allowfullscreen="true"
            frameborder="0" height="611" data-instgrm-payload-id="instagram-media-payload-11" scrolling="no"
            style="background: white; max-width: 540px; border-radius: 3px; border: 1px solid rgb(219, 219, 219); box-shadow: none; display: block; width: 255px; padding: 0px; height:460px">

    </iframe>
</template>

<script>
    export default {
        name: 'Post',
        props: {
            permalink: {
                default: 'https://www.instagram.com/p/B1H9cFPnF-H/',
                type: String
            }
        }
    }
</script>

<style scoped>

</style>
